import React, { useState } from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import CompanyProfile from './CompanyProfile';
import CompanyAccess from './CompanyAccess';
import * as Bixby from '$/core';
import BixButton from '$/components/global/bixButton';
import { getIsCurrentCompanyPublicState } from '$/store/company/selectors';
import CreatePublicCompanyTask from '../task/CreatePublicCompanyTask';

interface ICompanyOverviewProps {
  currentCompany?: Bixby.Models.AdminCompany;
  isCurrentCompanyPublic: boolean;
}

const CompanyOverview: React.FC<ICompanyOverviewProps> = ({ isCurrentCompanyPublic }) => {
  const [createPublicTaskActive, setCreatePublicTaskActive] = useState(false);
  return (
    <React.Fragment>
      <section>
        <CompanyProfile />
      </section>
      <section>
        {isCurrentCompanyPublic && (
          <div className="public-company-task-section">
            <p className="small_note">Public company, no client permissioning.</p>
            <BixButton onClick={() => setCreatePublicTaskActive(true)}>Create Public Task</BixButton>
            {createPublicTaskActive && (
              <CreatePublicCompanyTask onCloseModal={() => setCreatePublicTaskActive(false)} />
            )}
          </div>
        )}
        {!isCurrentCompanyPublic && <CompanyAccess />}
      </section>
    </React.Fragment>
  );
};

const mapStateToProps = (state: AppState) => {
  const { isCurrentCompanyPublic } = getIsCurrentCompanyPublicState(state);
  return { isCurrentCompanyPublic, curentCompany: state.companyState.currentCompany };
};

export default connect(mapStateToProps)(CompanyOverview);
